import { DatePicker, Form } from 'antd'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

const DateTimeInput = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  showTime = false,
  needConfirm = true,
  disabledFutureDate = true,
  disabledFutureTime = true,
  disabled = false,
  isRequired = true,
  hideLabel = false,
  wrapperClass = '',
}) => {
  const intl = useIntl()
  return (
    <Form.Item
      name={name}
      label={label}
      className={`${wrapperClass} ${hideLabel ? 'hide-label' : ''}`}
      rules={
        isRequired
          ? [
              {
                required: true,
                message: intl.formatMessage({id: 'validation.selectField'}, {label: label}),
              },
            ]
          : undefined
      }
    >
      <DatePicker
        showTime={showTime}
        needConfirm={needConfirm}
        style={{ width: '100%' }}
        placeholder={placeholder ?? label}
        disabled={disabled}
        value={value ? dayjs(value) : null}
        onChange={(date) => {
          onChange(date ? date.toISOString() : null)
        }}
        disabledDate={
          disabledFutureDate ? ((current) => current && current > dayjs().endOf('day')) : false
        }
        disabledTime={disabledFutureTime ? (
          (current) => {
            if (!current || !current.isSame(dayjs(), 'day')) {
              return {}
            }

            const now = dayjs()

            return {
              disabledHours: () =>
                Array.from({ length: 24 }, (_, i) => i).filter(
                  (hour) => hour > now.hour()
                ),

              disabledMinutes: (selectedHour) =>
                selectedHour === now.hour()
                  ? Array.from({ length: 60 }, (_, i) => i).filter(
                      (minute) => minute > now.minute()
                    )
                  : [],

              disabledSeconds: (selectedHour, selectedMinute) =>
                selectedHour === now.hour() && selectedMinute === now.minute()
                  ? Array.from({ length: 60 }, (_, i) => i).filter(
                      (second) => second > now.second()
                    )
                  : [],
            }
          }
        ) : () => false}
      />
    </Form.Item>
  )
}

export default DateTimeInput
